import { useState } from "react";
import { SearchFilterOptionType, ResourceType, ResourceSchema, FilterType } from "../../data/types";
import ResourceCard from '../../components/Desktop/ResourceCard'
import { useResource } from "../../contexts/appcontext";



const Recommendations = () => {
  const paginatedResources: any[] = []
  const isMobile = false
  const toggleApplyModal = () => null
  const setApplyResource = () => null
  const ResourceIcon = () => null

  const { globalFilter } = useResource();
  // const [resourceType, setResourceType] = useState<ResourceType>("kitchen");
  const resourceType: ResourceType = "kitchen"
  const [searchTerm, changeSearchTerm] = useState<string>("");
  const [currentFilter, setCurrentFilter] = useState<FilterType>(globalFilter);
  const [signInModalIsOpen, setSignInModalIsOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
  const [messagesOpen, setMessagesOpen] = useState(false);
  const [messageCommunityId, setMessageCommunityId] = useState<string | undefined>();

  const searchFilterOptions: SearchFilterOptionType = {
    searchTerm,
    currentFilter,
    signInModalIsOpen,
    messagesOpen,
    messageCommunityId,
    setMessagesOpen,
    setMessageCommunityId,
    changeSearchTerm,
    setCurrentFilter,
    setSignInModalIsOpen,
  }


  return (
    <div className="flex flex-col mx-auto sm:h-screen mt-6 rounded-xl">       
      {
        (
          paginatedResources && paginatedResources.length > 0) ? paginatedResources.map((resource: ResourceSchema, i: number) => (
            <ResourceCard 
              isMobile={isMobile} 
              key={i} 
              resourceType={resourceType} 
              resourceIcon={ResourceIcon} 
              resource={resource} 
              searchFilterOptions={searchFilterOptions} 
              toggleApplyModal={toggleApplyModal}
              setApplyResource={setApplyResource}
            />
          )
        ) : (
          <div className="flex flex-row justify-evenly font-light text-center text-[#013847]/60 text-xs sm:text-sm">
            No {resourceType} to show
          </div>
        )
      }
  </div>
  )
}

export default Recommendations